/**
 * SpeedyX Engine
 *
 * This is the fastest data loader you'll ever see in your life :P.
 *
 * @constructor
 */
// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;
(function ($) {

    "use strict";

    var pluginName = "speedyX",
        defaults = {
            /**
             * You must return a promise that return list of ids like this
             * [{'id': id.id},{'id': id.id},{'id': id.id}]
             */
            'loadIds': function () {

            },

            /**
             * accept data ids list e.g. [123,444,5213,23321]
             * and you must return a promise that resolve data like this with id attribute matched the set of ids
             * previously sent
             * [{'id':123,'name':'ahmad'},...etc]
             * @param ids
             */
            'loadIdsData': function (ids) {

            },
            // If set to true, speedyX will call load ids again when reach end of ids list available
            'allowPagination': false,
            // If set to true, pre loading will be limited to index +- range (if false, preloading will load #range of items after last element loaded)
            'limitBulkLoading': false,
            // range of data ( preloaded )
            'range': 2,

            // nunjucks template
            'template': '../modules/speedy_screen/views/ams_candidate_card.tmpl.html',

            // additional data to be attached when render thetemplatee
            'additionalData': {},
            'sliderContainerClass': ' <div class="speedyx-slider"></div>  ',

            // transition speed
            'speed': 250,

            'showProgress': false,

            'edgeLeftText': $filter('translate')('There are no candidates left to view'),
            'edgeRightText': $filter('translate')('You have reached the end of your search, try removing a filter to gain access to more candidates'),

            'containerClass': '',


            'isMobile': false,

            // callbacks
            'onHide': function () {
            },
            'beforeDestroy': function () {
            },
            'afterChange': function () {
            },
            'beforeChange': function () {
            },
            'beforeRender': function (data, callback) {
                callback(data);
            },
            'onRendered': function () {
            },
            'onScroll': function () {
            },
            'beforeRemoveSlide': function () {
            },

            // lock certain actions on nav
            'lockNavigationOn':function(){
                return false;
            },
            'loadSpeedyArrowsViewData': function () {
            },
            'showArrowsData': false,
        };

    /**
     * The actual plugin constructor
     *
     * @param element
     * @param options
     * @constructor
     */
    function SpeedyX(element, options) {

        var self = this;

        // public variable
        self.element = element;
        self.settings = $.extend({}, defaults, options);
        self._defaults = defaults;
        self._name = pluginName;


        // private variables

        // ids list
        var listOfIds = null;
        var listOfIdsReverseIndex = {};
        var slickContainerRef = null;
        var dataIndexStr = 'data-speedyx-unique-index';
        var templateEngine = getAngularService('DispatcherServices').getNunjucks();
        var cachedTemplate;
        var currentIndex = null;
        var lastIndex = null;
        var rightEdgedReached = false;
        var leftEdgedReached = false;
        var loadingPrecentage = 0;
        var currentlyLoading = false;
        var idsBeingLoaded = false;
        var noMoreIds = false;
        var activeId;
        var $element = $(self.element);
        var animLocker;
        var dontMove = false;
        var direction = null;
        var lock = false;
        var nextActiveId = false;
        var prevActiveId = false;
        var slickRef;
        var FIRST_SLIDE = 1;
        var SECOND_SLIDE = 2;
        var EXTRA_TIMEOUT = 200;


        /**
         * generate reverse index
         */
        var buildReverseIndex = function () {
            if (listOfIds.length == 0) {
                return self.hide();
            }

            for (var i = 0; i < listOfIds.length; i++) {
                if( isInt(listOfIds[i].id) ){
                    listOfIdsReverseIndex[listOfIds[i].id] = i;
                }
                else{
                    //console.log(listOfIds[i].id, ' is not INT ', listOfIds[i])
                }
            }

            currentIndex = (listOfIdsReverseIndex[activeId] != null) ? listOfIdsReverseIndex[activeId] : currentIndex;
        };

        /**
         * generate of unloaded indexes
         *
         * @param index
         * @returns {Array}
         */
        var getIndexes2Load = function (index) {
            if( !listOfIds ){
                return [];
            }
            var indexes2load = [];

            if (self.settings.limitBulkLoading) {
                var startIndex = index - self.settings.range;
                startIndex = (startIndex < 0) ? 0 : startIndex;

                var endIndex = index + self.settings.range;

                if (endIndex >= listOfIds.length) {
                    endIndex = listOfIds.length - 1;

                    // Try to load next page of ids if pagination allowed and not being loaded already
                    if (self.settings.allowPagination && !idsBeingLoaded && !noMoreIds) {
                        idsBeingLoaded = true;

                        self.settings.loadIds(listOfIds.length).done(function (ids) {

                            if (!listOfIds) {
                                console.warn("List of ids doesn't exists after loading more");
                                return;
                            }

                            if (ids.length == 0) {
                                noMoreIds = true;
                            }

                            idsBeingLoaded = false;
                            // Append new ids to the already existing list of ids
                            listOfIds = listOfIds.concat(ids);

                            buildReverseIndex();
                        });
                    }
                }

                for (var i = startIndex; i <= endIndex; i++) {
                    if (!listOfIds[i]['data']) {
                        indexes2load.push(listOfIds[i].id);
                    }
                }
            }
            else {
                var size = 0;

                for (var i = index; i < listOfIds.length && size <= self.settings.range; i++) {
                    if (!listOfIds[i].hasOwnProperty('data')) {
                        indexes2load.push(listOfIds[i].id);
                        size++;
                    }
                }

                size = 0;

                for (var i = index; i >= 0 && size <= self.settings.range; i--) {
                    if (!listOfIds[i].hasOwnProperty('data')) {
                        indexes2load.push(listOfIds[i].id);
                        size++;
                    }
                }
            }


            return indexes2load;
        };


        /**
         * go to specific slide
         *
         * @param id
         * @param dontAnimate
         */
        var goTo = function (index, dontAnimate) {
            slickRef.slick('slickGoTo', index, dontAnimate);
            updateView();
        };


        /**
         * Item loaded
         *
         * @param index
         * @returns {*|boolean}
         */
        var itemLoaded = function (index) {

            if( !listOfIds ){
                return false;
            }

            var item = listOfIds[index];
            return item && item.hasOwnProperty('data');
        };


        /**
         * isRendered
         *
         * @param index
         * @returns {boolean}
         */
        var isRendered = function (index) {
            var item = listOfIds[index];
            return item.hasOwnProperty('rendered') && item.rendered === true;
        };

        /**
         * setActiveId
         *
         * @param index
         */
        var setActiveId = function (index) {

            if( !listOfIds ){
                return;
            }

            activeId = listOfIds[index].id;

            nextActiveId = listOfIds[index + 1 < listOfIds.length ? index + 1 : listOfIds.length - 1].id;
            prevActiveId = listOfIds[index - 1 > 0 ? index - 1 : 0].id;

        };

        /**
         * loadId
         *
         * @param id
         * @param isIndex
         * @returns {*}
         */
        var loadId = function (id, isIndex) {
            var dfd = $q.defer();
            var index = isIndex ? id : listOfIdsReverseIndex[id];
            var isItemLoaded = itemLoaded(index);

            setActiveId(index);

            if (isItemLoaded) {
                dfd.resolve({'index': index, 'dontAnimate': true});
            }

            getSpatialData(index).then(function (data) {
                if (!isItemLoaded) {
                    dfd.resolve({'index': index, 'dontAnimate': true});
                }
            });

            return dfd.promise;
        };


        /**
         * get spatial data
         * load data based on data location ( spatially relative to index ) in listOfIds array
         * @param index
         * @returns {*}
         */
        var getSpatialData = function (index) {
            var ids2load = getIndexes2Load(index);
            return loadIdsRange(ids2load);
        };

        /**
         * Load id
         * either load it from cached data or grabbed from server
         *
         * @param id
         * @param isIndex
         * @returns {*}
         */
        var loadIdsRange = function (ids2load) {

            var dfd = $q.defer();
            if (ids2load.length > 0) {

                var loadDataPromises = self.settings.loadIdsData(ids2load, listOfIds, listOfIdsReverseIndex);
                loadDataPromises.forEach(function (promise) {
                    promise.then(
                        // Success handler
                        function (data) {

                            if( !listOfIds ){
                                return;
                            }

                            data.forEach(function (item) {
                                var itemIndex = listOfIdsReverseIndex[item.id];
                                listOfIds[itemIndex].data = item;
                                if (item.id === activeId) {
                                    dfd.resolve({'status': 'success'});
                                }
                            });
                        },
                        // Error handler
                        function (err) {
                            console.error("Error loading data for for SpeedyScreen", err);
                            dfd.reject({'status': err});
                        }
                    );
                });
            }
            else {
                dfd.reject({'status': 'ids2load must be array with length > 0'});
            }

            return dfd.promise;
        };

        /**
         * go to next slide
         *
         * @param noGoTo
         */
        self.goNext = function (callback, forceTransition) {

            forceTransition = typeof forceTransition != "undefined"?  forceTransition: true;

            if (animLocker || rightEdgedReached || dontMove || self.settings.lockNavigationOn()) {
                return;
            }

            animLocker = true;
            slickRef.slick('slickSetOption', 'swipe', false);

            // check if it left edged
            if (!leftEdgedReached) {
                lastIndex = currentIndex;
                currentIndex = currentIndex + 1 >= listOfIds.length ? currentIndex : currentIndex + 1;
            }
            else {
                currentIndex = 0;
                lastIndex = false;
            }
            direction = 'right';

            addSlide('<div></div>');

            loadCurrentElem(currentIndex).then(function () {

                if( !listOfIds){
                    return;
                }

                render(listOfIds[currentIndex], SECOND_SLIDE).then(function () {

                    if (forceTransition) {
                        goTo(SECOND_SLIDE);
                    }

                    if (callback) callback();

                    setTimeout(function () {
                        removeSlide(FIRST_SLIDE);
                        // ensure we are on the same slide because we have two empty div to activate mobile browsing
                        goTo(FIRST_SLIDE, true);

                        // render next and prev on mobile to activate smooth mobile slide
                        if (self.settings.isMobile) {
                            renderPrevNext(currentIndex, FIRST_SLIDE);
                        }
                    }, self.settings.speed+EXTRA_TIMEOUT);

                    unlockAnim();
                });

            }, function () {
                console.log('No nExt')
            });
        };

        /**
         * go to prev slide
         * @param noGoTo
         */
        self.goBack = function (callback, forceTransition) {

            forceTransition = typeof forceTransition != "undefined"?  forceTransition: true;

            if (animLocker || leftEdgedReached || dontMove || self.settings.lockNavigationOn()) {
                return;
            }

            animLocker = true;
            slickRef.slick('slickSetOption', 'swipe', false);
            // check if it right edged
            if (!rightEdgedReached) {
                lastIndex = currentIndex;
                currentIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : 0;
            }
            else {
                currentIndex = listOfIds.length - 1;
                lastIndex = false;
            }

            direction = 'left';
            addSlide('<div></div>', FIRST_SLIDE, true);
            // slick set first slide to 0 if we prepend another slide the active will be 0
            // while the correct active slide is 1 so move to 1
            goTo(SECOND_SLIDE, true);

            loadCurrentElem(currentIndex).then(function () {

                render(listOfIds[currentIndex], FIRST_SLIDE).then(function () {

                    if (forceTransition) {
                        goTo(FIRST_SLIDE);
                    }

                    if (callback) callback();

                    setTimeout(function () {
                        removeSlide(SECOND_SLIDE);
                        goTo(FIRST_SLIDE, true);

                        // render next and prev on mobile to activate smooth mobile slide
                        if (self.settings.isMobile) {
                            renderPrevNext(currentIndex, FIRST_SLIDE);
                        }
                    }, self.settings.speed+EXTRA_TIMEOUT);

                    unlockAnim();

                }, function(){
                     unlockAnim();
                });
            });

        };


        /**
         * renderPrevNext
         *
         * @param index
         * @param slide
         */
        var renderPrevNext = function (index, slide) {

            if (listOfIds[index + 1] && !rightEdgedReached) {

                loadCurrentElem(index + 1).then(function(){
                    render(listOfIds[index + 1], slide + 1);
                });

            }

            if (listOfIds[currentIndex - 1] && !leftEdgedReached) {

                loadCurrentElem(index - 1).then(function(){
                    render(listOfIds[index - 1], slide - 1);
                });

            }
        };

        /**
         * used to prevent multi animation request
         */
        var unlockAnim = function () {
            setTimeout(function () {
                animLocker = false;
                slickRef.slick('slickSetOption', 'swipe', true);
            }, self.settings.speed + EXTRA_TIMEOUT);
        };

        /**
         * update view elements depend on the status
         */
        var updateView = function () {

            if (!listOfIds) {
                console.warn("Updating view but listOfIds no longer exists: listOfIds=", listOfIds);
                return;
            }

            rightEdgedReached = currentIndex === listOfIds.length - 1 && lastIndex === listOfIds.length - 1;
            leftEdgedReached = currentIndex === 0 && lastIndex === 0;


            //show hide arrows
            if (leftEdgedReached) {
                $element.find('#speedyx-left-edge').show();
                $element.find('.go-left').hide();
            }
            else {
                $element.find('#speedyx-left-edge').hide();
                $element.find('.go-left').show();
            }

            if (rightEdgedReached) {
                $element.find('#speedyx-right-edge').show();
                $element.find('.go-right').hide();
            }
            else {
                $element.find('#speedyx-right-edge').hide();
                $element.find('.go-right').show();
            }

            if (leftEdgedReached || rightEdgedReached) {
                slickContainerRef.find('.slick-track').hide();
                $element.find('#speedyx-progress').hide();
                slickRef.slick("slickRemove", 0);
                slickRef.slick("slickAdd", "<div></div>");
            }
            else {
                slickContainerRef.find('.slick-track').show();
                $element.find('#speedyx-progress').show();
            }

            // @TODO improve naming
            self.settings.afterChange(activeId, $element, $element.find('.slick-active'));

            var totalCount = (self.settings.getTotalCount && self.settings.getTotalCount()) || listOfIds.length;
            loadingPrecentage = currentIndex / (totalCount - 1) * 100;

            $element.find('#speedyx-progress>div').attr('aria-valuenow', loadingPrecentage).css('width', loadingPrecentage + '%');

            if (listOfIds.length == 1) {
                $element.find('.go-right, .go-left').hide();
                dontMove = true;
            }

        };

        /**
         * trigger keyboard key
         *
         * @param key
         */
        var triggerKey = function (key) {
            var e = jQuery.Event("keydown");
            e.which = key; // # Some key code value
            $(document).trigger(e);
        };


        var removeAll = function () {
            $('.slick-slide').each(function () {
                slickRef.slick('slickRemove');
            })
        };

        var updateArrowsViewData = function (cardIndex, slickIndex) {
            var isSpeedyxLeftEdgeShown = currentIndex === 0 && lastIndex === 0;
            var isSpeedyxRightEdgeShown = listOfIds && listOfIds.length - 1 && lastIndex === listOfIds.length - 1;
            self.settings.loadSpeedyArrowsViewData(cardIndex, isSpeedyxLeftEdgeShown, isSpeedyxRightEdgeShown, listOfIdsReverseIndex)
                .then(function (speedyArrowsViewData){
                    var rightArrowContent = speedyArrowsViewData && speedyArrowsViewData.nextEmployee;
                    var leftArrowContent = speedyArrowsViewData && speedyArrowsViewData.previousEmployee;
                    $element.find('[data-slick-index=' + slickIndex + ']').parents('.harri-speedyx-modal').first().find('.speedyx-arrow.ss-arrow-left').html(getArrowTemplate('left', leftArrowContent));
                    $element.find('[data-slick-index=' + slickIndex + ']').parents('.harri-speedyx-modal').first().find('.speedyx-arrow.ss-arrow-right').html(getArrowTemplate('right', rightArrowContent));
                })
                .catch(function (err) {
                    console.error(err);
                });
        };


        /**
         * render item data
         *
         * @param item
         * @param index
         */
        var render = function (item, slickIndex) {
            var dfd = $q.defer();
            if (item && item.data) {
                var item_data = item.data;
                item_data = $.extend(true, item_data, self.settings.additionalData);

                var doRendering = function (template) {
                    self.settings.beforeRender(item_data, function (modifiedItemData) {
                        var htmlString = template.render(modifiedItemData);
                        var newItem = $(htmlString);
                        $element.find('[data-slick-index=' + slickIndex + ']').html(newItem);
                        if (self.settings.showArrowsData) {
                            updateArrowsViewData(item_data.id, slickIndex);
                        }
                        self.settings.onRendered(newItem, modifiedItemData);
                        dfd.resolve();
                    });
                };

                if (cachedTemplate) {
                    doRendering(cachedTemplate);
                }
                else {
                    var template = templateEngine.getTemplate(self.settings.template, true);
                    cachedTemplate = template;
                    doRendering(cachedTemplate);
                }
            }
            else{
                dfd.reject();
            }

            return dfd.promise;
        };

        /**
         * show loading based on direction
         *
         * @param direction
         */
        var loading = function () {
            if (direction == 'left') {
                self.settings.showArrowsData ? $element.find('.go-left').addClass('loading') : $element.find('.go-left').addClass('fa-refresh fa-spin').removeClass('fa-chevron-left');
            }
            else if (direction == 'right') {
                self.settings.showArrowsData ? $element.find('.go-right').addClass('loading') : $element.find('.go-right').addClass('fa-refresh fa-spin').removeClass('fa-chevron-right');;
            }
        };

        /**
         * hide loading
         *
         */
        var hideLoading = function () {
            self.settings.showArrowsData ? $element.find('.go-left').removeClass('loading') : $element.find('.go-left').addClass('fa-chevron-left').removeClass('fa-refresh fa-spin');
            self.settings.showArrowsData ? $element.find('.go-right').removeClass('loading') : $element.find('.go-right').addClass('fa-chevron-right').removeClass('fa-refresh fa-spin');
        };


        /**
         * loadCurrentElem
         */
        var loadCurrentElem = function (index, dontGoTo) {
            var dfd = $q.defer();
            if (index && itemLoaded(index)) {
                var currentItem = listOfIds[index];
                activeId = currentItem.id;
                currentlyLoading = false;
                dfd.resolve(index);
            }
            else {
                currentlyLoading = true;
                loading();
            }


            if (!lock) {
                loadId(index, true).then(function (res) {
                    hideLoading();
                    currentlyLoading = false;
                    lock = false;
                    // initial case load not loaded
                    dfd.resolve(index);
                }, function () {
                    lock = false;
                });
            }

            return dfd.promise;
        };

        // starting point
        var init = function () {
            $element.html(self.settings.sliderContainerClass);
            slickContainerRef = $element.find('.speedyx-slider');
            var localize = $injector.get("localize");
            var isRTL = localize.isRTL();
            slickRef = slickContainerRef.slick({
                slidesToShow: 1,
                rtl: isRTL,
                infinite: false,
                slidesToScroll: 1,
                speed: self.settings.speed,
                accessibility: false,
                arrows: false,
                draggable: false,
            });
            const initModalCount = $('.modal:visible').length;

            slickRef.on('afterChange', function(){

            });

            slickRef.on('swipe', function (event, slick, direction) {
                if (direction == 'left') {
                    self.goNext(null, false);
                }
                else {
                    self.goBack(null, false);
                }
                loadId(currentIndex, true);
                updateView();
            });


            $(document).unbind('keydown');
            $(document).keydown(function (e) {

                // if there is a modal on top of speed screen return;
                if($('.modal:visible').length > initModalCount){
                    return;
                }

                if (animLocker || currentlyLoading || self.settings.lockNavigationOn() ) {
                    return;
                }

                if (e.target.tagName && ["input", "textarea", "select"].indexOf(e.target.tagName.toLowerCase()) > -1) {
                    return;
                }

                switch (e.which) {
                    case 39: // right
                        e.preventDefault();
                        self.goNext();
                        break;
                    case 37: // left
                        e.preventDefault();
                        self.goBack();
                        break;
                    case 27: // Esc
                        e.preventDefault();
                        self.hide();
                        break;
                    default:
                        return; // exit this handler for other keys
                }

                // if already in progress
               // hideLoading();

            });

            $element.scroll(function () {
                self.settings.onScroll($element, $element.find('.slick-active'));
            });


            if (self.settings.showProgress) {
                slickContainerRef.append('<div class="progress speedyx-progress" id="speedyx-progress" style="display: none;"> \
                                          <div class="progress-bar progress-bar-striped" role="progressbar" aria-valuenow="' + loadingPrecentage + '" aria-valuemin="0" aria-valuemax="100" style="width: ' + loadingPrecentage + '%">\
                                            <span class="sr-only"> ' + loadingPrecentage + '% Complete (success)</span>\
                                          </div>\
                                        </div>');
            }

            if (self.settings.showArrowsData) {
                slickContainerRef.append('<div class="ams-loading-spinner"></div><div class="go-right speedyx-arrow transform-direction ss-arrow-right" id="ss-arrow-right" style="display: none;"></div><div class="go-left speedyx-arrow transform-direction ss-arrow-left" id="ss-arrow-left" style="display: none;"></div>');
            } else {
                slickContainerRef.append('<div class="ams-loading-spinner"></div><i class="fa fa-chevron-right go-right speedyx-arrow transform-direction" id="ss-arrow-right" style="display: none"></i> <i class="fa fa-chevron-left go-left  ss-arrow-left speedyx-arrow transform-direction" id="ss-arrow-left" style="display: none"></i>');
            }
            slickContainerRef.append('<div class="candidate-card-modal padding-xs" id="speedyx-left-edge" style="display: none">\
                             <a class="speedyx-close close" data-dismiss="modal" href="#"><span class="fa fa-times"></span></a>\
                             <div class="cand-card-content no-more-cands">\
                               <div class="h-text f18 gray text-center">\
                                  <div class="fa fa-long-arrow-right fa-3x transform-direction"></div>\
                                 <div class="space-xs"></div>\
                                 <div class="h-text h13 normal">' + self.settings.edgeLeftText + '</div> \
                               </div>\
                             </div>\
                           </div>');


            slickContainerRef.append('<div class="candidate-card-modal padding-xs" id="speedyx-right-edge" style="display: none">\
                             <a class="speedyx-close close " data-dismiss="modal" href="#"><span class="fa fa-times"></span></a>\
                             <div class="cand-card-content no-more-cands">\
                               <div class="h-text f18 gray text-center">\
                                  <div class="fa fa-long-arrow-left fa-3x transform-direction"></div>\
                                 <div class="space-xs"></div>\
                                 <div class="h-text h13 normal">' + self.settings.edgeRightText + '</div>\
                               </div>\
                             </div>\
                           </div>');


            $element.find('.go-left').on('click touchstart', function () {
                 if (animLocker || currentlyLoading) {
                    return;
                }
                self.goBack();
            });

            $element.find('.go-right').on('click touchstart', function () {
                if (animLocker || currentlyLoading) {
                    return;
                }
                self.goNext();
            });



            $element.find('#ss-arrow-right').on('click touchstart', function () {
                if (animLocker || currentlyLoading) {
                    return;
                }
                self.goNext(null, !self.settings.isMobile );
            });

            $element.find('#ss-arrow-left').on('click touchstart', function () {
                if (animLocker || currentlyLoading) {
                    return;
                }
                self.goBack(null, !self.settings.isMobile);
            });

            if (typeof self.settings.containerClass == 'string') {
                $element.addClass(self.settings.containerClass);
            }
            else if (typeof self.settings.containerClass == 'function') {
                $element.addClass(self.settings.containerClass());
            }

            // disable document arrow event  propagation to prevent other issues when navigate through textarea
            $element.on('keydown','textarea, input', function(e){
                e.stopPropagation();
            });
        };

        /**
         * Ensure that slick indexes are synced
         */
        var refreshSlickIndexes = function () {
            $element.find('.slick-slide').each(function (i, v) {
                $(this).attr('data-slick-index', i);
            })
        };


        var addSlide = function (html, index, addBefore) {
            slickRef.slick('slickAdd', html, index, addBefore);
            refreshSlickIndexes();
        };

        var removeSlide = function (index) {
            self.settings.beforeRemoveSlide(index, $element.find('[data-slick-index='+index+']'));
            slickRef.slick('slickRemove', index);
            refreshSlickIndexes();
        };


        var getArrowTemplate = function (direction, employeeDetails) {
            if (employeeDetails) {
                var employeeImage = "url('" + MediaUtils.hUserProfileImage([employeeDetails.profile_image_uuid, employeeDetails.user_id], '_image_profile_full', true) + "')";
                return '<div class="speedyx-loader"><i class="fa fa-refresh fa-spin"></i></div>\
                      <div class="speedyx-image-arrow" style="background-image:' + employeeImage + '">\
                      <div class="image-overlay d-flex justify-content-center align-items-center ' + direction + '-image"><i class="transform-direction fa fa-angle-' + direction + '"></i></div></div>\
                      <div class="employee-details">\
                      <div class="employee-name mt-2">' + employeeDetails.first_name + ' ' + employeeDetails.last_name + '</div>\
                      <div class="employee-info">' + (employeeDetails.position ? employeeDetails.position.name : '') + (employeeDetails.brand_name ? (' | ' + employeeDetails.brand_name) : '') + '</div>\
                      </div>';
            } else {
                return '<div class="speedyx-loader"><i class="fa fa-refresh fa-spin"></i></div>\
                      <div class="speedyx-image-arrow">\
                      <div class="image-overlay empty-arrow d-flex justify-content-center align-items-center ' + direction + '-image"><i class="transform-direction fa fa-angle-' + direction + '"></i></div>\
                      </div>';
            }
        };

        /**
         * show the speedy screen
         *
         * @param id
         * @param reload
         * @param reload
         */
        self.show = function (id, reload) {

            $element.show();
            $('body').addClass('speedyX-open');


            addSlide('<div></div>');
            addSlide('<div></div>');
            addSlide('<div></div>');


            activeId = id;

            if (reload === true) {
                listOfIds = null;
            }

            if (!listOfIds) {
                idsBeingLoaded = true;
                // 0 is the amount of current loaded ids, used for pagination when allowed
                self.settings.loadIds(0).done(function (data) {
                    idsBeingLoaded = false;
                    if ($.isArray(data)) {
                        listOfIds = data;
                        buildReverseIndex();
                        currentIndex = listOfIdsReverseIndex[id];
                        loadId(id).then(function (data) {
                            $element.find('.ams-loading-spinner').remove();
                            render(listOfIds[currentIndex], FIRST_SLIDE).then(function () {
                                goTo(FIRST_SLIDE, true);
                                // render next and prev on mobile to activate smooth mobile slide
                                if (self.settings.isMobile) {
                                    renderPrevNext(currentIndex, FIRST_SLIDE);
                                }
                            });
                        });
                    }
                    else {
                        console.error('SpeedyX: listOfIds must be an array');
                    }
                });
            }
            else {
                // loadCurrentElem( listOfIdsReverseIndex[activeId], true );
                currentIndex = listOfIdsReverseIndex[activeId];

                loadCurrentElem(currentIndex, true).then(function () {
                    goTo(FIRST_SLIDE, true);
                    // render next and prev on mobile to activate smooth mobile slide
                    if (self.settings.isMobile) {
                        renderPrevNext(currentIndex, FIRST_SLIDE);
                    }
                });
            }
        };

        /**
         * Hide Modal
         */
        self.hide = function (callback) {
            $element.css('display','none');
            $('body').removeClass('speedyX-open');
            if (callback) callback();
            self.settings.onHide($element);
        };

        /**
         * destroy plugin data
         */
        self.destroy = function () {
            listOfIds = null;
            self.settings.beforeDestroy($element);
            $element.hide();
            $('body').removeClass('speedyX-open');
            $.data(self.element, "plugin_" + pluginName, null);
            $(document).unbind('keydown');
            $element.empty();
        };

        /**
         * Replace in item with another
         * @param oldItemId
         * @param newItemId
         */
        self.replaceItem = function (oldItemId, newItemId) {

            var oldItemIndex = listOfIdsReverseIndex[oldItemId];
            var newItemIndex = listOfIdsReverseIndex[newItemId];



            if (newItemIndex > oldItemIndex) {
                listOfIds.splice(newItemIndex, 1);
                listOfIds.splice(oldItemIndex, 1);
                // Insert new item just after the old one
                listOfIds.splice((oldItemIndex+1), 0, {id: newItemId});
                buildReverseIndex();
            }

            var timer = setInterval(function() {
                if (!animLocker) {
                    self.goNext(function () {
                    });
                    clearInterval(timer);
                }
            }, 100);

        };

        self.idExists = function(id, callback) {
            callback(listOfIdsReverseIndex && Object.keys(listOfIdsReverseIndex).indexOf(id.toString()) > -1);
        };

        self.addItemData = function(id, data) {
            var itemIndex = listOfIdsReverseIndex[id];
            listOfIds[itemIndex].data = data;
        };

        /**
         * Close modal
         */
        $element.click(function (e) {
            if (e.target == self.element) {
                self.hide();
            }
        });

        $element.on('click', '.speedyx-close', function (e) {
            e.stopPropagation();
            e.preventDefault();
            self.hide();
        });

        init();
    }


    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {

        // convert method to array and store it in method args
        var methodArgs = Array.prototype.slice.call(arguments);

        return this.each(function () {
            var objectInstance = $.data(this, "plugin_" + pluginName);

            // call public method from jquery plugin
            if (typeof options == "string" && objectInstance) {
                objectInstance[options].apply(objectInstance, methodArgs.slice(1));
            }
            else if (typeof options != "string" && !objectInstance) {
                objectInstance = new SpeedyX(this, options);
                $.data(this, "plugin_" + pluginName, objectInstance);
            }
        });
    };

})(jQuery);
